module.exports = __webpack_public_path__ + "static/media/banner_mobile_02022024.335226e7.jpg";